export default __webpack_public_path__ + "static/media/puppyFemalePurple2.802d314e.jpg";